import React from "react";
import { Box, Typography, Grid, TextField, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';

function CompanyInfoPage({ companyInfo }) {
  return (

    <Box sx={{ p: 3 }}>
      {/* Companies House Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", display: "flex", alignItems: "center",color:"black" }}>
          Companies House
          <IconButton size="small" sx={{ ml: 1, color: "primary.main" }}>
            <LaunchRoundedIcon fontSize="small"  sx={{color:"blue"}}/>
          </IconButton>
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body2" sx={{ fontWeight: 550 ,color:"black" }}>
              Company Name
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField fullWidth size="small" variant="outlined" sx={{ bgcolor: "#f9f9f9" }} disabled value={companyInfo.companyName} />
          </Grid>

          <Grid item xs={4}>
            <Typography variant="body2" sx={{ fontWeight: 550,color:"black" }}>
              Companies House Number
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField fullWidth size="small" variant="outlined" sx={{ bgcolor: "#f9f9f9" }} disabled value={companyInfo.companyHouseNo} />
          </Grid>

          <Grid item xs={4}>
            <Typography variant="body2" sx={{ fontWeight: 550,color:"black" }}>
              Registered Address
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField value={companyInfo.registrationAddress} fullWidth multiline rows={3} size="small" variant="outlined" sx={{ bgcolor: "#f9f9f9" }} disabled />
          </Grid>
        </Grid>
      </Box>

      {/* Deadlines Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" ,color:"black"}}>
          Deadlines
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body2" sx={{ fontWeight: 550 ,color:"black"}}>
              Next Year End Date
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField fullWidth size="small" variant="outlined" sx={{ bgcolor: "#f9f9f9" }} disabled />
          </Grid>

          <Grid item xs={4}>
            <Typography variant="body2" sx={{ fontWeight: 550 ,color:"black"}}>
              Confirmation Statement Date
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField fullWidth size="small" variant="outlined" sx={{ bgcolor: "#f9f9f9" }} disabled value={companyInfo.confirmationStatementDate} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  
  );
}

export default CompanyInfoPage;
